import { memo } from 'react';
import { LoginTemplate } from 'components/templates/LoginTemplate';

type Props = {};

export const LoginPage = memo((_props: Props) => {
	return <LoginTemplate />;
});
